import {create} from 'zustand'
import {acionsTypesCardtable, Action, Dispatch} from '../../logic/actionsType'
import {ICardtable, IFootNote, ILegalRequestFileType, IRequest, IRequestZamen} from '../../../interfaces'

type TCardTableState = {
  CardTableList?: ICardtable[]
  CardTableData?: ICardtable | undefined
  RequestData?: IRequest
  CardTableListIsFetching?: boolean
  currentPage?: number
  search?: string
  pageSizeC?: number
  showAcceptModal?: boolean
  showComplateModal?: boolean
  showWaitingModal?: boolean
  legalRequestType?: ILegalRequestFileType[]
  showExistModal?: boolean
  showExistArchiveModal?: boolean
  showChangeResponseTimeModal?: boolean
  totalRecords?: number | undefined
  selectedId?: number | undefined
  chequesType?: number | undefined
  historyId?: number | undefined
  complateTime?: string | undefined
  complateTimeView?: string | undefined
  showTime?: boolean | undefined
  showFileVoiceModal?: boolean
  fileVoice?: string | undefined
  footNotes?: IFootNote[]
  showAddRequestFile?: boolean
  showStepModal?: boolean
  stepRequest?: {
    step1?: boolean
    step2?: boolean
    step3?: boolean
    step4?: boolean
    step5?: boolean
    step6?: boolean
  }
  showModalZamenCount?: boolean
  showModalZamenChequeCount?: boolean
  showModalZamenChequeDelete?: boolean
  showRejectModal?: boolean
  zamenCount?: number
  zamenPlaceCount?: number
  zamenLegalCount?: number
  zamenChequesCount?: number
  requestZamen?: IRequestZamen[]
  showArchiveModal?: boolean
}

type State = {
  state: TCardTableState
}

const reducer = (
  state: State,
  action: Action<keyof typeof acionsTypesCardtable, TCardTableState>
): State => {
  switch (action.type) {
    case 'ADD_CARDTABLE_LIST':
      return {state: {...state.state, CardTableList: action.payload.CardTableList}}
    case 'LOADING_CARDTABLE_LIST':
      return {
        state: {...state.state, CardTableListIsFetching: action.payload.CardTableListIsFetching},
      }
    case 'TOTALRECORD_CARDTABLE_LIST':
      return {state: {...state.state, totalRecords: action.payload.totalRecords}}
    case 'CURRENTTPAGE_CARDTABLE_LIST':
      return {state: {...state.state, currentPage: action.payload.currentPage}}
    case 'PAGESIZE_CARDTABLE_LIST':
      return {state: {...state.state, pageSizeC: action.payload.pageSizeC}}
    case 'SEARCH_CARDTABLE_LIST':
      return {state: {...state.state, search: action.payload.search}}
    case 'SELECTEDID_CARDTABLE_LIST':
      return {state: {...state.state, selectedId: action.payload.selectedId}}
    case 'SHOWCOMPLATEMODAL_CARDTABLE_LIST':
      return {state: {...state.state, showComplateModal: action.payload.showComplateModal}}
    case 'SHOWWAITINGMODAL_CARDTABLE_LIST':
      return {state: {...state.state, showWaitingModal: action.payload.showWaitingModal}}
    case 'SHOARCHIVEMODAL_CARDTABLE_LIST':
      return {state: {...state.state, showArchiveModal: action.payload.showArchiveModal}}
    case 'CHEQUESTYPE_CARDTABLE_LIST':
      return {state: {...state.state, chequesType: action.payload.chequesType}}
    case 'SHOEXISTARCHIVEMODAL_CARDTABLE_LIST':
      return {state: {...state.state, showExistModal: action.payload.showExistModal}}
    case 'RESPONSETIMENEXT_CARDTABLE_LIST':
      return {
        state: {
          ...state.state,
          showChangeResponseTimeModal: action.payload.showChangeResponseTimeModal,
        },
      }
    case 'SHOWACCEPTMODAL_CARDTABLE_LIST':
      return {state: {...state.state, showAcceptModal: action.payload.showAcceptModal}}
    case 'GET_DETAIL_CARDTABLE':
      return {state: {...state.state, RequestData: action.payload.RequestData}}
    case 'SET_HISTORYID_CARDTABLE':
      return {state: {...state.state, historyId: action.payload.historyId}}
    case 'SHOWFILEVOICE_CARDTABLE':
      return {state: {...state.state, showFileVoiceModal: action.payload.showFileVoiceModal}}
    case 'FILEVOICE_CARDTABLE':
      return {state: {...state.state, fileVoice: action.payload.fileVoice}}
    case 'FOOTNODE_CARDBOARD':
      return {state: {...state.state, footNotes: action.payload.footNotes}}
    case 'SET_DATE_TIME':
      return {state: {...state.state, complateTime: action.payload.complateTime}}
    case 'SET_DATE_TIME_VIEW':
      return {state: {...state.state, complateTimeView: action.payload.complateTimeView}}
    case 'SHOW_DATE_TIME':
      return {state: {...state.state, showTime: action.payload.showTime}}
    case 'SHOW_ADD_REQUEST_FILE':
      return {state: {...state.state, showAddRequestFile: action.payload.showAddRequestFile}}
    case 'SHOW_STEP_MODAL':
      return {state: {...state.state, showStepModal: action.payload.showStepModal}}
    case 'SET_STEP_REQUEST':
      return {state: {...state.state, stepRequest: action.payload.stepRequest}}
    case 'SHOW_ZAMEN_COUNT':
      return {state: {...state.state, showModalZamenCount: action.payload.showModalZamenCount}}
    case 'SHOW_ZAMEN_CHEQUE_COUNT':
      return {
        state: {
          ...state.state,
          showModalZamenChequeCount: action.payload.showModalZamenChequeCount,
        },
      }
    case 'SHOW_ZAMEN_CHEQUE_DELETE':
      return {
        state: {
          ...state.state,
          showModalZamenChequeDelete: action.payload.showModalZamenChequeDelete,
        },
      }
    case 'SET_ZAMEN_COUNT':
      return {state: {...state.state, zamenCount: action.payload.zamenCount}}
    case 'SET_ZAMEN_CHEQUE_COUNT':
      return {state: {...state.state, zamenChequesCount: action.payload.zamenChequesCount}}
    case 'SET_ZAMEN_LIST':
      return {state: {...state.state, requestZamen: action.payload.requestZamen}}
    case 'SHOW_REJECT_MODAL':
      return {state: {...state.state, showRejectModal: action.payload.showRejectModal}}
    case 'SET_ZAMEN_LEGAL_COUNT':
      return {state: {...state.state, zamenLegalCount: action.payload.zamenLegalCount}}
    case 'SET_ZAMEN_PLACE_COUNT':
      return {state: {...state.state, zamenPlaceCount: action.payload.zamenPlaceCount}}
    default:
      return state
  }
}

export const useCardtableStore = create<
  State & Dispatch<keyof typeof acionsTypesCardtable, TCardTableState>
>((set) => ({
  state: {
    CardTableList: [],
    showAcceptModal: false,
    showComplateModal: false,
    showChangeResponseTimeModal: false,
    showWaitingModal: false,
    showArchiveModal: false,
    showExistModal: false,
    showExistArchiveModal: false,
    CardTableData: undefined,
    CardTableListIsFetching: false,
    zamenChequesCount: 1,
    selectedId: undefined,
    pageSizeC: 10,
    totalRecords: undefined,
    currentPage: 0,
    search: '',
    RequestData: undefined,
    chequesType: 1,
    historyId: undefined,
    showModalZamenChequeDelete: false,
    showFileVoiceModal: false,
    fileVoice: undefined,
    footNotes: [],
    showAddRequestFile: false,
    showStepModal: false,
    stepRequest: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
    },
    showModalZamenCount: false,
    zamenLegalCount: 1,
    zamenPlaceCount: 1,
    zamenCount: 1,
  },
  dispatch: (action) => {
    set((state: State) => reducer(state, action))
  },
}))
